module.exports = __webpack_public_path__ + "img/banner_10.f995c0f9.png";